import { useRouter } from 'next/router';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

type AdFlagOption = 'google' | 'mgid' | 'cazamba';

export default function useScriptFlag({ adFlag }: { adFlag: AdFlagOption }) {
  const router = useRouter();

  if (publicRuntimeConfig.NEXT_PUBLIC_ENVIRONMENT === 'production') return true;

  const flags = {
    google: 'google',
    mgid: 'mgid',
    cazamba: 'cazamba',
  } as const;

  if (flags[adFlag] in router.query) {
    if (router.query[flags[adFlag]] === '0') return false;
  }

  return true;
}
